import { actionTypes } from './actions';
import { Map } from 'immutable';
import { createReducer } from 'utils/redux';

const initialState = Map({
  loading: false,
  error: '',
  data: null,
});

const onStartTaxExemptions = (state) => state.set('loading', true);

const onSuccessTaxExemptions = (state, { payload }) =>
  state.set('loading', false).set('data', payload).set('error', '');

const onErrorTaxExemptions = (state, { payload }) =>
  state.set('loading', false).set('error', payload);

export default createReducer(initialState, {
  [actionTypes.TAX_EXEMPTIONS_REQUEST_START]: onStartTaxExemptions,
  [actionTypes.TAX_EXEMPTIONS_REQUEST_SUCCESS]: onSuccessTaxExemptions,
  [actionTypes.TAX_EXEMPTIONS_REQUEST_FAILURE]: onErrorTaxExemptions,
});
